import React from "react";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";

/**
 * Inline "create new channel" panel. Producer-only — parent gates the
 * render. Composed by ChannelsTab.
 *
 * Props:
 *   creationCost — credits required to launch (from /me/channels config)
 *   handle       — current handle input value (lifted to parent so parent
 *                  can reset on cancel/submit success)
 *   onHandle     — handle setter
 *   busy         — true while POST /channels is in flight
 *   onSubmit     — invoked on Create click; parent calls the API + reloads
 *   onCancel     — closes the panel and clears the input
 */
const ChannelCreatePanel = ({ creationCost, handle, onHandle, busy, onSubmit, onCancel }) => (
  <div className="bg-gray-950 border border-emerald-500/30 rounded-lg p-3 mb-4">
    <p className="text-xs text-gray-400 mb-2">
      Pick a handle — viewers will NEVER see this is connected to your other channels.
    </p>
    <div className="flex gap-2">
      <Input
        value={handle}
        onChange={(e) => onHandle(e.target.value)}
        placeholder="e.g. coffee-radar"
        maxLength={32}
        className="bg-black border-gray-700 text-white text-sm flex-1"
        data-testid="new-channel-input"
      />
      <Button
        onClick={onSubmit}
        disabled={busy || !handle.trim()}
        className="bg-emerald-600 hover:bg-emerald-700 text-sm"
        data-testid="new-channel-submit"
      >
        {busy ? "Creating..." : `Create · ${creationCost} cr`}
      </Button>
      <Button
        variant="outline"
        onClick={onCancel}
        className="border-gray-700 text-gray-300 text-sm"
      >
        Cancel
      </Button>
    </div>
  </div>
);

export default ChannelCreatePanel;
